import { NgModule } from '@angular/core';
import { ResponsiveTableDirective } from './responsive-table.directive';

@NgModule({
  imports: [],
  declarations: [ResponsiveTableDirective],
  exports: [ResponsiveTableDirective],
})
export class ResponsiveTableModule {}
